import React from 'react';
import Icon from 'components/AppIcon';

function formatRupees(value) {
  if (value >= 10000000) return `₹${(value / 10000000)?.toFixed(1)}Cr`;
  if (value >= 100000) return `₹${(value / 100000)?.toFixed(1)}L`;
  return `₹${value?.toLocaleString('en-IN')}`;
}

export default function PipelineMetrics({ metrics }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
      {metrics?.map((m) => (
        <div
          key={m?.label}
          className="rounded-xl p-3"
          style={{ background: 'var(--color-card)', border: '1px solid var(--color-border)' }}
        >
          <div className="flex items-center justify-between mb-2">
            <div
              className="flex items-center justify-center rounded-lg"
              style={{ width: 30, height: 30, background: m?.bg }}
            >
              <Icon name={m?.icon} size={14} color={m?.color} />
            </div>
            {m?.change != null && m?.change !== '' && (
              <span
                className="font-caption text-xs font-semibold px-1.5 py-0.5 rounded-full"
                style={{ background: '#DCFCE7', color: '#15803D' }}
              >
                {m?.change}
              </span>
            )}
          </div>
          <div className="font-heading font-bold text-base" style={{ color: 'var(--color-foreground)' }}>
            {m?.value}
          </div>
          <div className="font-caption text-xs mt-0.5" style={{ color: 'var(--color-text-secondary)' }}>
            {m?.label}
          </div>
        </div>
      ))}
    </div>
  );
}
